import PropTypes from 'prop-types';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';

import { SQUARE } from '@utils/image';
import { getRouteUrl } from '@utils/urls';

import { PRODUCT, SHOP_EVENT_PRODUCT } from '@common/routes.mjs';
import { PRODUCT_TYPE } from '@common/constants/products';
import { SectionTitle } from '../Content.styled';

import {
  Thumbnail,
  ThumbnailGrid,
  ThumbnailLink,
  ColorValue,
} from './ColorVariations.styled';

const ColorVariations = ({
  colorVariations,
  productColorId,
  colorTitle,
  productType,
  withSmallSpacing,
}) => {
  const {
    i18n: { language },
    t,
  } = useTranslation();
  const route =
    productType === PRODUCT_TYPE.SHOP_EVENT ? SHOP_EVENT_PRODUCT : PRODUCT;

  return (
    <>
      <SectionTitle
        data-testid="productColor"
        withSmallSpacing={withSmallSpacing}
      >
        {`${t('productDetails.color', 'Farbe')}: `}
        <ColorValue>{colorTitle}</ColorValue>
      </SectionTitle>
      <ThumbnailGrid>
        {colorVariations.map(
          ({
            productColorId: id,
            colorTitle: variationTitle,
            images,
            slug,
          }) => (
            <Link
              key={id}
              legacyBehavior
              href={{
                pathname: route,
                query: { id, slug },
              }}
              as={getRouteUrl(language, route, { id, slug })}
              scroll
              passHref
            >
              <ThumbnailLink isSelected={id === productColorId}>
                <Thumbnail
                  alt={variationTitle}
                  breakpoints={[50]}
                  aspectRatios={SQUARE}
                  src={images?.[0]}
                />
              </ThumbnailLink>
            </Link>
          ),
        )}
      </ThumbnailGrid>
    </>
  );
};

ColorVariations.propTypes = {
  colorVariations: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      productColorId: PropTypes.string,
      colorTitle: PropTypes.string,
      images: PropTypes.arrayOf(PropTypes.string),
    }),
  ).isRequired,
  productColorId: PropTypes.string.isRequired,
  colorTitle: PropTypes.string.isRequired,
  productType: PropTypes.oneOf([PRODUCT_TYPE.DEFAULT, PRODUCT_TYPE.SHOP_EVENT])
    .isRequired,
  withSmallSpacing: PropTypes.bool,
};

ColorVariations.defaultProps = {
  withSmallSpacing: false,
};

export default ColorVariations;
